import creditCard from '../constants/credit-card';

app.constant('creditCard', {
  CARD_LIST_LIMIT: creditCard.CARD_LIST_LIMIT,
  BRAND_ICON_MAP: creditCard.BRAND_ICON_MAP,
  CARD_SCHEME_LIST: creditCard.CARD_SCHEME_LIST,
  SPECIFIC_CREDIT_TYPE: creditCard.SPECIFIC_CREDIT_TYPE,
});
